import React from 'react';

import NewHistorySlider from './NewHistorySlider/NewHistorySlider';

import styled from 'styled-components';

export default function History() {
  return (
    <StyledHistory>
      <StyledHistoryContentsContainer>
        <StyledTag>OUR HISTORY</StyledTag>
        <StyledTitle>
          인텔리퀀트 팀은 오늘도 진실된 마음으로 <br />
          발걸음을 내딛고 있습니다.
        </StyledTitle>
      </StyledHistoryContentsContainer>
      <StyledHistoryImage
        alt="history image"
        src="images/Home/history/group-9@2x(new).png"
      />
      <StyledMobileHistoryImage>
        <NewHistorySlider />
      </StyledMobileHistoryImage>
    </StyledHistory>
  );
}

const StyledHistory = styled.article`
  padding: 200px 0 130px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.black};
  border-bottom: 1px solid #252525;

  ${({ theme }) => theme.mobile`
    padding-top 96px;
    text-align: center;
  `}
`;

const StyledHistoryContentsContainer = styled.div`
  max-width: 1340px;
  padding: 0 30px;
  margin: 0 auto;
`;

const StyledTag = styled.h2`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.pixelToRem(14)};
`;

const StyledTitle = styled.h3`
  margin-bottom: 67px;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.pixelToRem(30)};
  font-weight: 700;

  ${({ theme }) => theme.mobile`
  font-size: ${({ theme }) => theme.pixelToRem(24)};
  margin-bottom: 70px;
  `}
`;

const StyledHistoryImage = styled.img`
  display: block;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledMobileHistoryImage = styled.div`
  display: none;
  background-image: url('images/Home/history/group-33@3x.png');
  background-size: cover;
  background-position: 20% 50%;
  background-repeat: no-repeat;

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;
